module.exports = __webpack_public_path__ + "img/buffet.c43fb6d2.png";